(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 51396:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(20620);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27068);
/* harmony import */ var _lib_route_Redirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47116);
/* harmony import */ var _src_components_navbar_NavbarLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71858);
/* harmony import */ var _src_components_auth_SignInPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50359);






function Index() {
    var user = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_1__/* .useSelfie */ .yD)();
    if (user) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_lib_route_Redirect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            to: "/"
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_components_navbar_NavbarLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        pb: 0,
        isLoggingIn: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_components_auth_SignInPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            signingIn: false
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,9932,8593,9774,2888,179], function() { return __webpack_exec__(51396); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);